import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Extract a human-readable error message from an API error response.
 * Handles Pydantic validation errors (array of objects) and simple string errors.
 * @param {any} error - The error object from axios catch block
 * @param {string} fallbackMessage - Default message if no detail found
 * @returns {string} Human-readable error message
 */
export function getApiErrorMessage(error, fallbackMessage = 'Error en la operación') {
  const errorDetail = error?.response?.data?.detail;
  
  if (!errorDetail) {
    return error?.message || fallbackMessage;
  }
  
  if (typeof errorDetail === 'string') {
    return errorDetail;
  }
  
  if (Array.isArray(errorDetail)) {
    return errorDetail
      .map(e => e.msg || e.message || (typeof e === 'string' ? e : JSON.stringify(e)))
      .join(', ');
  }
  
  if (typeof errorDetail === 'object') {
    return errorDetail.msg || errorDetail.message || JSON.stringify(errorDetail);
  }
  
  return fallbackMessage;
}
